import * as React from 'react';
import cn from 'classnames';
import { Button } from '@cian/ui-kit/button';
import * as styles from '../../styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var SkipButton = function SkipButton(props) {
  var loading = props.loading,
      children = props.children,
      onClick = props.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles['submit'], loading && styles['loading']),
    children: /*#__PURE__*/_jsx(Button, {
      type: "button",
      theme: "fill_secondary",
      size: 'M',
      "data-testid": "next",
      loading: loading,
      onClick: onClick,
      children: children
    })
  });
};
SkipButton.displayName = 'SkipButton';